var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUltimateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: ".5556in",
    height: ".5556in",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e56a5;}.cls-2{fill:#52934e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.9156,23.5219C5.3523,24.1443,0,15.0578,0,15.0578c0,0,4.9167,14.1554,22.8407,13.9859,7.5319-.0712,13.1619-2.7941,17.1593-5.9274l-4.6513-5.4782c-4.1118,2.9926-9.3916,5.6256-15.4331,5.8838Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.4457,12.6378c-3.3384,2.9858-8.2176,5.0196-13.5485,5.2414C8.9178,18.1696,3.0168,15.2776,0,10.9547v.0003s4.2943,11.5089,18.173,11.5089c6.2357,0,11.3523-2.4082,15.0976-5.0604l-3.8242-4.7657h-.0007Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUltimateIcon);
export default __webpack_public_path__ + "static/media/ultimate-icon.895f4fe3f64ab8d433a47af340af7923.svg";
export { ForwardRef as ReactComponent };